import { render, staticRenderFns } from "./HelpBox.vue?vue&type=template&id=9d007126&scoped=true&"
import script from "./HelpBox.vue?vue&type=script&lang=js&"
export * from "./HelpBox.vue?vue&type=script&lang=js&"
import style0 from "./HelpBox.vue?vue&type=style&index=0&id=9d007126&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d007126",
  null
  
)

export default component.exports